import { api } from "./api";

export async function startCheckout(packageId) {
  const { data } = await api.post("/payments/checkout", {
    package_id: packageId,
    origin_url: window.location.origin,
  });
  if (data.url) {
    window.location.href = data.url;
  } else {
    throw new Error("No checkout URL returned");
  }
}
